<script>
    import HeaderMenu from "../HeaderMenu.svelte";
    import '../nail-style.css';
    import './style.css';
  </script>
  
    <svelte:head>
    <title>Bit By Bit</title>
    <meta property="og:title" name="title" content="Bit By Bit" />
    <meta property="og:description" name="description" content="Are you spending too much time adjusting the
    RPM's during your nail services? Use this guide to
    make sure you're making the most of your e-file
    and your time."/>
    <meta property="og:image" name="image" content="/images/nail-style-blog/og-image/bit-by-bit.jpg"/>
    <meta property="og:article:published_time" content="05.09.23" />
    <script async src="//www.instagram.com/embed.js"></script>
  </svelte:head>
  
  <div class="container">
    <HeaderMenu></HeaderMenu>
    <div class="main-container">
      <div class="card-container top-card">
          <div class="shadow-pop-up">
              <div class="img-container">
                  <img class="first-image" src="/images/nail-style-blog/bit-by-bit/16858-GEL-CORE-GoFileIQ-Glam-Phot06.jpg" srcset="/images/nail-style-blog/bit-by-bit/16858-GEL-CORE-GoFileIQ-Glam-Phot06@2x.jpg 2x" alt="Gelish Go File IQ">
                  <!-- <a href="https://www.facebook.com/GelishProfessionalPage"><i class="fas fa-download-one"><img class="social-icons" src="/images/nail-style-blog/how-to-plan/icons8-facebook-black (1).svg" alt="Facebook"></i></a> -->
                  <!-- <a href="https://www.instagram.com/GelishProfessional/"><i class="fas fa-download-two"><img class="social-icons" src="/images/nail-style-blog/how-to-plan/icons8-instagram-black (1).svg" alt="Instagram"></i></a> -->
              </div>
              <div class="card-text">
                  <div class="card-category">
                      <a href="https://www.facebook.com/GelishProfessionalPage/" target="_blank">
                          <img class="social-icon-top-right" src="/images/nail-style-blog/fun-in-the-sun/icons8-facebook (1).jpg" srcset="/images/nail-style-blog/fun-in-the-sun/icons8-facebook (1)@2x.jpg 2x" alt="Facebook - Gelish">
                      </a>
                      <a href="https://www.instagram.com/gelishprofessional/?hl=en" target="_blank">
                          <img class="social-icon-top-right" src="/images/nail-style-blog/fun-in-the-sun/icons8-instagram (1).jpg" srcset="/images/nail-style-blog/fun-in-the-sun/icons8-instagram (1)@2x.jpg" alt="Instagram - Gelish">
                      </a>
                  </div>
                  <div class="title-card">Bit By Bit</div>
                  <div class="description-card">
                      Are you spending too much time adjusting the<br class="hide-br"> RPM's during your nail services? Use this guide to<br class="hide-br"> make sure you're making the most of your e-file<br class="hide-br"> and your time.
                  </div>
                  <div class="date-text">
                      <div class="by-gelish">BY GELISH</div>
                      <div class="date">05.09.23</div>
                  </div>
              </div>
          </div>
      </div>
  
      <div class="text-container" style="margin-top: 10px;">
          <p class="main-text">
              Setting the RPM on your e-file each time you go through an entire nail service takes a considerable amount of effort.
          </p>
          <p class="main-text">
              Have you even considered how much time you could have left over if switching that setting was easier and faster?
          </p>
      </div>
  
      <hr class="after-main-text-divider">
  
      <div class="text-container">
          <p class="after-main-text">While you're thinking about what you could do with that time,
              take a look at the new Gelish Go File IQ. This hybrid e-file uses patent-pending smart technology to instantly adjust your RPM with a single press of a button.
              The Go File IQ comes with three RPM zone presets that you can use, or you can program it to your own speeds for a custom experience.
              Plus, the e-file has all the other must-have features you want: it's lightweight, quiet, compact, portable, files while charging, acetone resistant and meets all safety standards.
          </p>
          <p class="after-main-text">
              Now, take a look at these four popular bits used for a nail service, and see how easily you can switch the zones on the Go File IQ with just the push of a button:
          </p>
      </div>
  
      <div class="bit-by-bit-master-ctr">
          <div class="bit-by-bit-row">
              <div class="bit-by-bit-col">
                  <img class="bit-by-bit-img" src="/images/nail-style-blog/bit-by-bit/BitByBitS1.jpg" srcset="/images/nail-style-blog/bit-by-bit/BitByBitS1@2x.jpg 2x" alt="Bit - Gelish Cuticle Cleaner Ball">
              </div>
              <div class="bit-by-bit-col bbb-text-col">
                  <p><strong>Bit:</strong> Gelish Cuticle Cleaner Ball</p>
                  <p><strong>Best For:</strong> Removing dead skin around the cuticle as part of nail prep.</p>
                  <p><strong>Suggested RPM:</strong> 7,000 - 10,000</p>
                  <p><strong>Gelish Go FIle IQ Setting:</strong> Zone 1</p>
              </div>
          </div>
          <div class="bit-by-bit-row">
              <div class="bit-by-bit-col">
                  <img class="bit-by-bit-img" src="/images/nail-style-blog/bit-by-bit/BitByBitS2.jpg" srcset="/images/nail-style-blog/bit-by-bit/BitByBitS2@2x.jpg 2x" alt="Bit - Gelish Coarse 3-in-1 Safety Edge Angled and Tapered">
                  <div class="bbb-text-col">
                      <p><strong>Bit:</strong> Gelish Coarse 3-in-1 Safety Edge Angled and Tapered Bit</p>
                      <p><strong>Best For:</strong> Precise removal of the outgrowth of gel over the nail enhancement while protecting the natural nail.</p>
                      <p><strong>Suggested RPM: 10,000 - 14,000</strong></p>
                      <p><strong>Gelish Go File IQ Setting:</strong> Zone 2</p>
                  </div>
              </div>
              <div class="bit-by-bit-col">
                  <img class="bit-by-bit-img" src="/images/nail-style-blog/bit-by-bit/BitByBitS3.jpg" srcset="/images/nail-style-blog/bit-by-bit/BitByBitS3@2x.jpg 2x" alt="Bit - Gelish Coarse Large Barrel">
                  <div class="bbb-text-col">
                      <p><strong>Bit:</strong> Gelish Coarse Large Barrel Bit</p>
                      <p><strong>Best For:</strong> Quickly and easily shortening and shaping any nail enhancement before a fill, or soak-off.</p>
                      <p><strong>Suggested RPM:</strong> 20,000 - 25,000</p>
                      <p><strong>Gelish Go File IQ Setting:</strong> Zone 3</p>
                  </div>
              </div>
          </div>
          <div class="bit-by-bit-row">
              <div class="bit-by-bit-col">
                  <img class="bit-by-bit-img" src="/images/nail-style-blog/bit-by-bit/BitByBitS4.jpg" srcset="/images/nail-style-blog/bit-by-bit/BitByBitS4@2x.jpg 2x" alt="Bit - Gelish Loxo Mandrel">
                  <div class="bbb-text-col">
                      <p><strong>Bit:</strong> Gelish Loxo Mandrel</p>
                      <p><strong>Best For:</strong> Use throughout the entire service thanks to the variety of sanding band grits available, and ideal for smoothing and finishing the surface of an enhancement.</p>
                      <p><strong>Suggested RPM:</strong> 7,000 - 10,000</p>
                  </div>
              </div>
              <div class="bit-by-bit-col">
                  <div class="iframe-ctr">
                      <iframe class="responsive-iframe" src="https://www.youtube.com/embed/4lbZZOgHWGo?rel=0" title="Gelish Go File IQ - YouTube Short" frameborder="0" allowfullscreen></iframe>
                  </div>
              </div>
          </div>
      </div>
  
      <div class="card-container-previous-article" style="margin-top: 100px;">
          <div style="border-top: 1.9px solid #707070;">
              <div class="prev-article" style="margin-top: 90px; margin-bottom:60px;">Previous articles</div>
          </div>
          <a style="text-decoration: none; color: #262626; margin-bottom:15px;" href="/nail-style-blog/making-waves">
              <div class="bottom-article">
                  <div>
                      <img class="danny-prev-img" src="/images/nail-style-blog/fun-in-the-sun/16916-GELMT-SUMMER%202023-HAND%20GLAM-PHOTOSHOOT-Group-Gelish2.jpg" srcset="/images/nail-style-blog/fun-in-the-sun/16916-GELMT-SUMMER%202023-HAND%20GLAM-PHOTOSHOOT-Group-Gelish2@2x.jpg 2x" alt="Fun In The Sun - Article">
                  </div>
  
                  <div class="prev-article-category-text prev-article-change-margin">
                      <div class="note-from-danny note-from-danny-category">FUN IN<br class="hide-br"> THE SUN</div>
                      <div class="prev-article-description">Get ready for fun in the sun with these six brilliant summer shades.</div>
                      <div class="note-date">05.03.23</div>
                  </div>
              </div>
          </a>
      </div>
  </div>
  </div>

  <style>
.card-category img{
    width: 22px;
    height: auto;
  }
  .img-container .first-image {
    width: 458px;
  }
  .flip-black {
    background: black;
    color: white;
  }
  .drop-in-img-ctr{
    max-width: 680px;
    margin: 0 auto;
  }
  .product-oval-ctr a{
    text-decoration: none;
    margin-top:0;
  }
  hr.after-main-text-divider {
    margin-left: auto;
  margin-right:auto;
}
  </style>
  
  